module.exports = __webpack_public_path__ + "assets/img/12b8-bo.svg";